import * as angular from "angular";
import * as _ from "lodash";

export class DeliveryUtilsService {

  /* @ngInject */
  constructor(private $log) {}

  getTaskByPurpose(_tasks, _purpose) {

    if (_.isUndefined(_tasks) || _.isUndefined(_purpose)) {
      this.$log.error('Task list and / or purpose resolved to undefined! \n ' +
        '--> deliveryUtilsService@getTaskByPurpose');
    }

    if (_.isArray(_tasks)) {
      return _.find(_tasks, (_task) => {
        return _.isEqual(_.get(_task, 'taskSpec.purpose'), _purpose);
      });
    } else {
      this.$log.error('Task list must be an array! \n ' +
        '--> deliveryUtilsService@getTaskByPurpose');
    }
  }
}

angular
  .module('bringoz.admin.deliveries')
  .service('deliveryUtilsService', DeliveryUtilsService);
